<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="文件名" prop="title">
              <el-input
                v-model="formParameter.title"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="文件级别" prop="level">
              <el-select
                @change="changeLevel"
                v-model="formParameter.level"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in levelArr"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="文件类型" prop="dtype">
              <el-select v-model="formParameter.dtype" placeholder="请选择">
                <el-option
                  v-for="item in dtypeArr"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="开始时间" prop="starttm">
              <el-date-picker
                v-model="formParameter.starttm"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="结束时间" prop="endtm">
              <el-date-picker
                v-model="formParameter.endtm"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="不选默认五年"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="应用角色" prop="rolesids">
              <select-role-tree-dialog
                placeholder="默认为全部"
                multiple
                v-model="formParameter.rolesids"
                autocomplete="off"
              >
              </select-role-tree-dialog>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
         
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="文档内容:" prop="content">
              <wang-edit v-model="formParameter.content"></wang-edit>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"
              ><el-input
                type="textarea"
                placeholder="备注不会被展示"
                rows="3"
                v-model="formParameter.remark"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >添 加</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/oa/ossdoc.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import roleTree from "@/components/biz/roleTree/roleTree.vue";
import selectRoleTreeDialog from "@/components/biz/selectRoleTreeDialog/selectRoleTreeDialog.vue";

export default {
  name: "add",
  components: {
    popup,
    selectOptionDictionary,
    wangEdit,
    roleTree,
    selectRoleTreeDialog,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      levelArr: [],
      dtypeArr: [],
      me: {},
      rules: {
        level: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 11,
            trigger: "blur",
          },
        ],
        //标题
        title: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //公文正文
        content: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //开始时间
        starttm: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    changeLevel() {
       
    },
    //打开弹框
    open(parameter, title, disabled, size) {
       this.formParameter = {};
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, "75%");
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.formParameter={}
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        //添加
        let parameter = this.$utils.merger(this.formParameter);
        api.save(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.confirmLoading = false;
            this.close();
            this.$parent.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
            this.confirmLoading = false;
          }
        );
      });
    },
    init() {
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      // 前端取回自己
      this.me = this.$caches.user.get();

      if ("ad" == this.me.role) {
        this.levelArr = ["公司级", "市场部", "技术部"];
        this.dtypeArr = ["规章制度", "工作规范",  "产品资料",  "销售制度",  "招生宝典"];
      } else if ("mgr" == this.me.role2) {
        this.levelArr = ["市场部"];
        this.dtypeArr = ["规章制度", "工作规范",  "销售制度",  "招生宝典"];
      } else if ("mgr2" == this.me.role2) {
        this.levelArr = [ "技术部"];
        this.dtypeArr = ["规章制度", "工作规范",  "产品资料"];
      }
      this.formParameter.level = this.levelArr[0]
      
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

/deep/.w-e-text-container{
        height: 550px !important;/*!important是重点，因为原div是行内样式设置的高度300px*/
    }

</style>
